// src/utils/regexUtils.js
export const isValidName = (value)  => {
    const nameRegexPattern = /^(?![\s.,\/]*$)[0-9A-Za-z.,'"?&$\s\/()<>=:\-|]+$/;
    return nameRegexPattern.test(value);
}
